// eslint-disable-next-line @altermaind/you-shall-not-pass
import { AccountStatus } from '@/swagger/constants/anagraphics-enums';

export const it = {
  people: {
    pageTitle: 'Anagrafiche',
    noCompanyData: {
      title: 'Overview',
      description:
        'Non ci sono ancora anagrafiche inserite. Sincronizza le informazioni delle persone per iniziare a utilizzare la piattaforma con la tua azienda.',
      boxAlert: {
        title: 'Aggiungi anagrafiche',
        description:
          'Scegli come vuoi aggiungere i dipendenti: puoi caricare un file con più anagrafiche oppure inserirli manualmente, uno alla volta.',
        buttonLabel: 'Aggiungi',
      },
    },
    recapPeople: {
      current: {
        title: 'Totale anagrafiche',
        tooltip:
          'Numero complessivo di profili caricati e salvati in piattaforma. Potrai integrare nuove anagrafiche in qualsiasi momento utilizzando il tasto “+”.',
      },
      validProfile: {
        title: 'Profili validi',
        tooltip:
          'Anagrafiche complete di tutte le informazioni necessarie. Solo i profili validi possono ricevere l’assessment.',
      },
      invalidProfile: {
        title: 'Profili da correggere',
        tooltip:
          'Anagrafiche con dati incompleti o errati. Finché non verranno aggiornate, questi utenti non potranno ricevere l’assessment.',
      },
      cta: {
        fixProfiles: 'Revisiona e correggi',
      },
      noInvalid: {
        text1: 'Tutti i profili sono stati caricati correttamente! ',
        text2: "Procedi con l’invio dell'assessment",
      },
      survey: {
        title: 'Invia assessment',
        description:
          'Inizia a misurare le hard e soft skills dei dipendenti e raccogli i primi insight sulla tua organizzazione.',
        buttonLabel: 'Invia Assessment',
      },
    },
    usefullInformations: {
      title: 'Materiali utili',
      boxTutorial: {
        title: 'Tutorial',
        description: 'Impara a configurare la sezione Anagrafiche per iniziare subito',
        buttonLabel: 'Guarda ora',
      },
      boxTemplate: {
        title: 'Template anagrafiche',
        description:
          'Non hai un file? Scarica il nostro template e compilalo con i dati della tua azienda',
        buttonLabel: 'Scarica',
      },
    },
    status: {
      [AccountStatus.ENABLED]: 'Attivo',
      [AccountStatus.PENDING]: 'In sospeso',
      [AccountStatus.DISABLED]: 'Disattivo',
      [AccountStatus.NOT_INVITED]: 'Non attivo',
    },
    tableEmployees: {
      title: 'Elenco anagrafiche',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      role: 'Ruolo Aziendale',
      department: 'Dipartimento',
      status: {
        label: 'Stato',
        tooltip:
          'Stato utente\nNon attivo - profilo a cui non è ancora stato inviato l’assessment\nIn sospeso - profilo invitato ma non ancora attivo (invito scaduto o registrazione senza assessment completato)\nAttivo - utente registrato\nDisattivo - profilo disabilitato da HR (es. congedo o cessazione)',
      },
      bulkActionAssignDepartment: 'Assegna dipartimento',
      assignDepartmentBulkDialog: {
        title: 'Assegna dipartimento',
        subtitle: 'Seleziona un dipartimento esistente o creane uno nuovo',
        selectedCount: '({{count}} dipendenti selezionati)',
        existingDepartment: 'Dipartimento esistente',
        newDepartment: 'Nuovo dipartimento',
        selectDepartmentLabel: 'Dipartimento',
        selectDepartmentPlaceholder: 'Seleziona dipartimento',
        newDepartmentNameLabel: 'Nome dipartimento',
        newDepartmentNamePlaceholder: 'Inserisci il nome',
        newDepartmentDescription:
          'Definisci il nome del dipartimento e un eventuale responsabile, selezionabile solo tra i dipendenti non assegnati a dipartimenti o team.',
        managerLabel: 'Responsabile (facoltativo)',
        managerPlaceholder: 'Seleziona un responsabile',
        infoAlert:
          "Le modifiche relative a Team e Responsabili devono essere effettuate puntualmente all'interno di ogni singola anagrafica.",
        assign: 'Assegna',
        duplicateDepartmentName:
          'Nome già in uso. Inserisci un nome diverso o torna indietro per selezionare il dipartimento esistente.',
        assignCheckWarnings: {
          departmentBecomesEmpty: {
            singular:
              'Assegnando i dipendenti selezionati, il dipartimento "{{name}}" resterà senza membri e verrà eliminato automaticamente.',
            plural:
              'Assegnando i dipendenti selezionati, i dipartimenti "{{name}}" resteranno senza membri e verranno eliminati automaticamente.',
          },
          departmentLosesManager: {
            singular: 'Il dipartimento "{{name}}" resterà senza responsabile.',
            plural: 'I dipartimenti "{{name}}" resteranno senza responsabile.',
          },
        },
      },
    },
    filters: {
      fields: {
        roles: 'Ruoli',
        departments: 'Dipartimenti',
      },
      cta: {
        apply: 'Salva',
        reset: 'Reset',
        cancel: 'Annulla',
      },
      unknownDepartment: 'Non assegnato',
    },
    details: {
      tabs: {
        tab1: 'Profilo',
        tab2: 'Assessment',
        tab3: 'Crediti',
      },
      assessment: {
        title: '{{name}} assessment',
        emptyState: {
          title: 'Assessment',
          description: 'Non è ancora stato inviato nessun {{name}} assessment.',
        },
        alertBadge:
          'Il modello è in fase di validazione scientifica e mostra un livello di affidabilità consistente, soprattutto nella visualizzazione aggregata per team e dipartimenti',
        status: {
          completed: 'Completato il {{date}}',
          notCompleted: 'Inviato',
          noSurvey: 'Non inviato',
          tooltip: {
            completed: 'L’assessment è stato completato correttamente dall’utente.',
            notCompleted:
              'L’assessment è stato inviato, in attesa di completamento da parte dell’utente.',
            noSurvey: "L'assessment non è ancora stato inviato all'utente.",
          },
        },
        surveyTitle: {
          completed: 'Punteggio medio per {{name}}',
          notCompleted: 'Punteggio {{name}}',
        },
        userNotValid: {
          title: 'Assessment',
          description:
            'L’utente non è valido, correggi i dati per poter inviare il primo questionario.',
        },
        descriptionNotSent:
          "L'assessment non è stato ancora inviato a questo utente. Procedi all'invio per cominciare il percorso.",
        descriptionCompleted:
          'Il grafico riporta i punteggi medi (scala 0-7) delle {{metricsCount}} {{templateName}} considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
        descriptionNotCompleted:
          'L’assessment è stato inviato ma l’utente non l’ha ancora completato. Per sollecitare la compilazione, vai nella sezione {{templateName}} Assessment e clicca su “Invia reminder”.',
        goToSurvey: 'Vai al questionario',
        sendSurvey: 'Invia assessment',
        descriptionTitle: 'Descrizione',
        discoverModel: 'Scopri il modello',
      },
      credits: {
        tabs: {
          income: 'Entrate',
          spent: 'Uscite',
        },
        nextRecharge: 'Rinnovo crediti: !{DATE}! ({{days}} giorni rimanenti)',
        total: {
          label: 'Saldo totale disponibile',
          currentMonth: 'Crediti assegnati questo mese',
        },
        overall: 'Utilizzo dei crediti',
        overallTooltip:
          'La percentuale indica la quota di crediti utilizzati rispetto all’assegnazione complessiva disponibile per utente. Poiché i crediti si accumulano per tre mesi, l’utilizzo reale mensile può superare il 100%, anche se i valori visualizzati non andranno mai oltre tale soglia.',
        trend: 'Trend utilizzo crediti',
        averageMonthlyUsage: 'Utilizzo medio mensile',
        averageMonthlyUsageTooltip:
          'Indica quanti crediti in media il dipendente utilizza in un mese. La metrica serve a capire l’intensità di utilizzo della piattaforma a livello individuale.',
        fromNow: 'ad oggi {{date}}',
        trendLastMonths: 'Trend ultimo mese',
        trendLastMonthsTooltip:
          'Mostra l’aumento o la diminuzione percentuale dell’utilizzo medio per persona rispetto al mese precedente. Utile per individuare trend di crescita o calo.',
        versusPreviousMonth: 'vs mese precedente',
        creditLabel: 'crediti',
        history: {
          table: {
            title: 'Storico Crediti',
            activity: 'Attività',
            date: 'Data',
            credits: 'Crediti',
          },
          filters: {
            title: 'Filtri',
            buttons: {
              save: 'Salva',
              reset: 'Reset',
            },
            month: 'Mese',
            year: 'Anno',
          },
        },
        category: {
          filters: {
            label: 'Filtra per',
            monthly: 'Ultimo mese',
            quarterly: 'Ultimi 3 mesi',
            semester: 'Ultimi 6 mesi',
          },
        },
        lastThreeMonths: {
          table: {
            title: 'Crediti residui nell’ultimo trimestre',
            month: 'Mese',
            accumulatedCredits: 'Crediti accumulati',
            receivedCredits: 'Crediti ricevuti',
            residualCredits: 'Crediti residui',
            spentCredits: 'Crediti spesi',
            balance: 'Saldo',
            balanceTooltip: 'Crediti attualmente disponibili',
          },
        },
        incomeAndSpent: {
          noData: 'Nessun dato disponibile',
          title: 'Ripartizione dei crediti per attività',
          tooltip:
            'I dati mostrano la distribuzione complessiva dei crediti spesi e guadagnati nell’ultimo mese. La percentuale indica il peso medio delle attività sul totale.',
        },
        emptyState: {
          title: 'Crediti',
          description:
            "L'utente {{name}} non è ancora attivo su Slash o non ha ancora crediti assegnati. \nI crediti vengono visualizzati solo quando l'utente sarà attivo e verrà invitato al questionario.",
        },
      },
    },
    tutorial: {
      title: 'Gestisci profili',
      slides: {
        slide1: {
          title: 'Aggiungi anagrafiche',
          description:
            'Per caricare delle anagrafiche, clicca sul pulsante “Aggiungi” o sull’icona “+” e carica il file o procedi manualmente. Assicurati che ogni profilo contenga i seguenti campi: nome, cognome e mail. L’AI ti supporterà automaticamente nell’organizzazione e nella lettura dei dati.',
        },
        slide2: {
          title: 'Visualizza elenco anagrafiche',
          description:
            'Accedi all’elenco completo dei dipendenti e controlla lo stato utente (attivo, in sospeso, non attivo, disattivo). Verifica quanti profili sono già completi e quanti necessitano di correzioni prima di poter proseguire.',
        },
        slide3: {
          title: 'Revisiona e correggi',
          description:
            'Clicca sul pulsante “Revisiona e Correggi” per sistemare i profili con dati incompleti o errati. Solo i profili completi potranno ricevere l’assessment.',
        },
        slide4: {
          title: 'Dettaglio anagrafica',
          description:
            'Aprendo il profilo di ciascun dipendente puoi accedere a una vista completa delle sue informazioni. In “Profilo” trovi lo stato, i dati anagrafici, lavorativi e personali dell’utente, oltre ai rimandi agli assessment.',
        },
      },
    },
    importCompanyData: {
      wizard: {
        setData: {
          title: 'Carica anagrafiche',
          confirm: 'Avanti',
          previous: 'Anagrafiche',
        },
        verifyData: {
          title: 'Revisiona e correggi',
          confirm: 'Conferma',
          previous: 'Indietro',
        },
      },
      setData: {
        title: "Importa l'anagrafica aziendale",
        subtitle:
          'Carica il file con i profili da inserire o aggiornare.\nAssicurati che ogni profilo contenga i seguenti campi: Nome, Cognome, Email.',
        warning:
          'Puoi anche aggiungere i seguenti dati facoltativi per rendere le analisi più accurate: Data di nascita (gg-mm-aaaa), Ruolo aziendale, Dipartimento, Responsabile (nome, cognome, mail), Team, Codice fiscale, Job level.',
        downloadFile:
          'Non hai un file simile?\n!{DOWNLOAD_FILE}! e compilalo con i dati della tua azienda',
        downloadFileTitle: 'Non hai un file?',
        downloadLabel: 'Scarica il nostro template',
        downloadFileDescription:
          'Scarica il nostro template e compilalo con i dati della tua azienda',
        uploadedFiles: 'Documento caricato',
        loadingFile: {
          title: 'L’AI sta verificando i dati caricati',
          description: 'Le anagrafiche verranno presto visualizzate nella piattaforma',
        },
        infoBox:
          'Per informazioni o ricevere supporto nel caricamento, consulta la !{DOCS}! o !{CONTACT}!',
        labelDocs: 'guida',
        labelContact: 'contattaci',
        warningSaveBeforeQuit:
          '<b>Attenzione</b> Se esci senza avere completato la revisione e correzione del anagrafiche, il file caricato non verrà salvato. Assicurati di completare l’operazione prima di uscire.',
      },
      verifyData: {
        title: 'Verifica anagrafiche',
        subtitle:
          'Qui trovi il riepilogo delle anagrafiche caricate. Puoi confermarle così come sono o correggere eventuali dati mancanti: solo i profili completi saranno idonei a ricevere il questionario. Potrai sempre modificarli anche in seguito dalla sezione “Anagrafiche”.',
        dialogConfirmNavigateBack: {
          title: 'Anagrafiche non salvate',
          description:
            'Abbandonando questo step, le informazioni che hai inserito fino a questo momento non verranno salvate.',
          explicitQuestion: 'Sei sicuro di procedere?',
          cancel: 'Annulla',
          confirm: 'Sì, torna indietro',
        },
        editImportedProfiles: {
          title: 'Elenco anagrafiche',
          subtitle:
            'Qui trovi l’elenco delle anagrafiche che presentano problemi. Modificale per procedere con l’invio dell’assessment.\nRicorda: sono obbligatori solo nome, cognome ed email.\nGli altri campi sono facoltativi e potrai completarli o modificarli successivamente.',
          cta: {
            confirm: 'Conferma anagrafiche',
            deleteImportAndGoBack: 'Elimina e torna indietro',
          },
          table: {
            name: 'Nome',
            surname: 'Cognome',
            email: 'Email',
            birthDate: 'Data di nascita',
            role: 'Ruolo aziendale',
            department: 'Dipartimento',
            manager: 'Email responsabile',
            area: 'Area (team)',
            fiscalCode: 'Codice Fiscale',
            jobLevel: 'Job Level',
            filters: {
              title: 'Filtri',
              cta: {
                close: 'Chiudi',
              },
            },
          },
          infoBox: 'Per maggiori informazioni, consulta la !{DOCS}! o !{CONTACT}!',
          labelDocs: 'guida',
          labelContact: 'contattaci',
          filters: {
            importedProfileCompleted: 'Profili Completi',
            importedProfileIncompleted: 'Profili Incompleti',
            importedProfileAll: 'Tutti i Profili',
            cta: {
              submit: 'Applica',
              reset: 'Reset',
            },
          },
          successFeedback: 'Le modifiche sono state salvate con successo!',
        },
      },
    },
    dialogPendingImportEmployees: {
      title: 'Caricamento in sospeso',
      description:
        'È stato rilevato un file caricato ma non ancora confermato.\nDecidi come procedere per avere accesso alla sezione Anagrafiche.',
      cancel: 'Elimina e carica un nuovo file',
      confirm: 'Conferma e continua',
    },
    dialogImportEmployeesStillRunning: {
      title: 'L’AI sta verificando i dati caricati',
      description: 'Le anagrafiche verranno presto visualizzate nella piattaforma',
      confirm: 'Vai alla dashboard',
      cancel: 'Elimina e torna indietro',
    },
    addEmployee: {
      choiceDialog: {
        title: 'Aggiungi nuovi utenti',
        subtitle: 'Scegli come vuoi inserire i nuovi utenti in piattaforma',
        manual: {
          label: 'Inserisci manualmente',
          description: 'Aggiungi un utente alla volta compilando i suoi dati.',
        },
        import: {
          label: 'Importa file',
          description: 'Carica un file per aggiungere più utenti contemporaneamente.',
        },
      },
      formDialog: {
        title: 'Aggiungi nuovi utenti',
        subtitle: 'Inserisci i dettagli del nuovo utente',
        optionalDetails: 'Dettagli profilo (facoltativi)',
        infoAlert:
          "Completando tutti i campi, anche quelli facoltativi, permetti alla piattaforma di generare analisi più accurate e una lettura più chiara dell'organizzazione. Inserendo dipartimento, team e responsabile potrai visualizzare dati aggregati per area e insight ancora più strategici.",
        roleInfo: 'Informazioni di ruolo',
        personalDetails: 'Dettagli anagrafica',
        buttons: {
          cancel: 'Annulla',
          save: 'Salva',
        },
        errors: {
          emailAlreadyInUse: "L'email inserita è già in uso all'interno di questa organizzazione.",
          emailAlreadyRegistered:
            "Questa email è già stata registrata in piattaforma, prova con un'altra mail",
        },
      },
    },
    reviewAndFixEmployees: {
      title: 'Revisiona e correggi',
      description:
        'Qui trovi l’elenco delle anagrafiche che presentano problemi. Modificale per procedere con l’invio dell’assessment. \nRicorda: è necessario correggere solo i campi in rosso.\n Se hai indicato un responsabile, la email corrispondente deve già essere presente in anagrafica; in caso contrario, l’utente risulterà da correggere.',
      table: {
        name: 'Nome',
        surname: 'Cognome',
        email: 'Email',
        birthDate: 'Data di nascita',
        role: 'Ruolo aziendale',
        department: 'Dipartimento',
        manager: 'Email responsabile',
        area: 'Area (team)',
        fiscalCode: 'Codice Fiscale',
        jobLevel: 'Job Level',
      },
      successFeedback: 'Le modifiche sono state salvate con successo!',
    },
  },
};
